import store from '@/store'
import { mapGetters } from 'vuex'
/**
 * Get route data with post
 * @todo Нужно смотреть релизацию в хранилище
 * @param {Object} routeData
 */
function getRouteWithPost(routeData, clear) {
  return store.getters['app/layout/getPostRoute'](routeData)
  //return store.getters['app/layout/getRouteData'](routeData, clear)
}
/**
 * @todo Костыль для формирования маршрута с указанием поста
 * @param {Object} routeData
 */
function getPostRoute(routeData = {}) {
  return store.getters['app/layout/getPostRoute'](routeData)
}

export { getRouteWithPost, getPostRoute }

export default {
  computed: {
    ...mapGetters('app/layout', {
      $dmsRouteWithPost: 'getRouteData',
      $dmsPostRoute: 'getPostRoute'
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/routing/index.js